export default function alphaSort(a: string, b: string): number {
  if (!a || !b) return 0;
  const nameA = a.toLowerCase();
  const nameB = b.toLowerCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
}
